import commentThreadPath from './commentThreadPath';
import historyPath from './historyPath';
import postPath from './postPath';
import userPath from './userPath';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';

const NOTIFICATION_FRAGMENT = gql(`
  fragment notificationPath_notifications on Notification {
    id
    ... on CommentNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      comment {
        thread {
          ...commentThreadPath_thread
        }
      }
    }
    ... on ReactionNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      reaction {
        thread {
          ...commentThreadPath_thread
        }
      }
    }
    ... on HistoryNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      history {
        versionTo
        versionFrom
        post {
          ...historyPath_post
        }
      }
    }
    ... on InvitationNotification {
      # eslint-disable-next-line @graphql-eslint/require-selections
      invitation {
        acceptedUser {
          ...userPath_user
        }
      }
    }
    ... on PostNotification {
      post {
        ...postPath_post
      }
    }
  }
`);

export default function notificationPath(
  notifications: DocumentType<typeof NOTIFICATION_FRAGMENT>[],
) {
  const notification = notifications[0];
  const lastNotification = notifications[notifications.length - 1];
  if (!notification) {
    return '/';
  }

  if ('comment' in notification && notification.comment) {
    return commentThreadPath(notification.comment.thread) ?? '/';
  }
  if ('reaction' in notification && notification.reaction) {
    return commentThreadPath(notification.reaction.thread) ?? '/';
  }
  if (
    'history' in notification &&
    notification.history &&
    lastNotification &&
    'history' in lastNotification &&
    lastNotification.history
  ) {
    const { versionTo } = notification.history;

    const { versionFrom, post } = lastNotification.history;

    return historyPath(post, versionFrom, versionTo);
  }
  if ('invitation' in notification && notification.invitation?.acceptedUser) {
    return userPath(notification.invitation.acceptedUser);
  }
  if ('post' in notification && notification.post) {
    return postPath(notification.post);
  }
  return '/';
}
